import { render, staticRenderFns } from "./AdminPrice.vue?vue&type=template&id=6c0a14ae&scoped=true&"
import script from "./AdminPrice.vue?vue&type=script&lang=js&"
export * from "./AdminPrice.vue?vue&type=script&lang=js&"
import style0 from "./AdminPrice.vue?vue&type=style&index=0&id=6c0a14ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a14ae",
  null
  
)

export default component.exports